export function orderTaskCreating(state = false, action) {
  switch (action.type) {
    case 'ORDER_CREATE_TASK':
      return action.add || false
    case 'TASK_CREATE_SUCCESS':
      return false
    default:
      return state
  }
}

export function orderTaskEditing(state = false, action) {
  switch (action.type) {
    case 'ORDER_EDIT_TASK':
      return action.id || false
    case 'TASK_EDIT_SUCCESS':
      return false
    default:
      return state
  }
}

export function orderContactCreating(state = false, action) {
  switch (action.type) {
    case 'ORDER_CREATE_CONTACT':
      return action.add || false
    case 'CONTACT_CREATE_SUCCESS':
      return false
    default:
      return state
  }
}

export function orderContactEditing(state = false, action) {
  switch (action.type) {
    case 'ORDER_EDIT_CONTACT':
      return action.id || false
    case 'CONTACT_EDIT_SUCCESS':
      return false
    default:
      return state
  }
}
